import { useRef, type PropsWithChildren } from 'react';

import { createStore, type Store } from '../../../../core/store/store.js';
import { INITIAL_STATE } from '../constants.js';
import { MeterBarChartTooltipContext } from '../context/MeterBarChartTooltipContext.js';
import type { MeterBarChartTooltipState } from '../types/state.js';

export const StoreProvider = ({ children }: PropsWithChildren) => {
  const storeRef = useRef<Store<MeterBarChartTooltipState> | null>(null);

  storeRef.current = createStore({ ...INITIAL_STATE });

  return (
    <MeterBarChartTooltipContext.Provider value={storeRef.current}>
      {children}
    </MeterBarChartTooltipContext.Provider>
  );
};
